export default {
  namespaced: true,
  state: {
    ready: false,
  },
  mutations: {
    setIntercomReady(state) {
      state.ready = true;
    },
  },
  getters: {
    isIntercomReady(state) {
      return state.ready;
    },
  },
  actions: {
    hideIntercomIcon({ dispatch }) {
      dispatch('waitForIntercomBoot', () => {
        window.Intercom('hide');
        window.Intercom('update', {
          hide_default_launcher: true,
        });
      });
    },
    initialize({ commit, dispatch }, retryCount = 0, maxRetries = 100) {
      if (this.$app.$statsig?.ready) {
        const isEnabled = this.$app.$statsig.checkGate('chat_provider_intercom');

        if (isEnabled) {
          dispatch('waitForIntercomBoot', () => commit('setIntercomReady'));
        } else {
          dispatch('hideIntercomIcon');
        }
      } else if (retryCount < maxRetries) {
        setTimeout(() => dispatch('initialize', retryCount + 1, maxRetries), 100);
      }
    },
    openIntercom() {
      window.Intercom('show');
    },
    setup({ dispatch }) {
      dispatch('initialize');
    },
    showIntercomIcon({ dispatch }) {
      if (window.__VETSTER?.opensSupportChatOnLoad) {
        dispatch('openIntercom');
      }

      dispatch('waitForIntercomBoot', () => window.Intercom('update', {
        hide_default_launcher: false,
      }));
    },
    waitForIntercomBoot({ dispatch }, callback, retryCount = 0, maxRetries = 100) {
      if (window.Intercom?.booted) {
        callback();
      } else if (retryCount < maxRetries) {
        setTimeout(() => dispatch('waitForIntercomBoot', callback, retryCount + 1, maxRetries), 100);
      }
    },
  },
};
